const passthrough = ({ children = null }) => children;
export default passthrough;
